import { render } from "./PlanBuilding.vue?vue&type=template&id=4e0f5542&scoped=true"
import script from "./PlanBuilding.vue?vue&type=script&lang=js"
export * from "./PlanBuilding.vue?vue&type=script&lang=js"

import "./PlanBuilding.vue?vue&type=style&index=0&id=4e0f5542&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0f5542"]])

export default __exports__